import { IconButton } from '@hub/button'
import { CrossMediumIcon } from '@hub/icon'
import React, { useCallback } from 'react'
import { useNavigationContext } from './navigation-context'

type NavigationPanelCloseButtonProps = {
  isMobileOnly?: boolean
  onClick?: (
    event: React.MouseEvent,
    context: { isOpen: boolean | undefined }
  ) => void
}

export const NavigationPanelCloseButton: React.FC<
  React.PropsWithChildren<NavigationPanelCloseButtonProps>
> = ({ isMobileOnly, onClick }) => {
  const { isOpen, onClose } = useNavigationContext()

  const handleClick = useCallback<React.MouseEventHandler>(
    event => {
      onClick?.(event, { isOpen })
      if (event.isDefaultPrevented()) {
        return
      }
      onClose?.(true)
    },
    [isOpen, onClick, onClose]
  )
  return (
    <IconButton
      variant="transparent"
      colorScheme="licorice"
      size="icon-lg"
      icon={<CrossMediumIcon boxSize="size-icon-md" />}
      onClick={handleClick}
      aria-label={'close navigation menu'}
      sx={
        isMobileOnly
          ? {
              display: [null, null, 'none'],
            }
          : undefined
      }
    />
  )
}
